import { autoinject, useView } from 'aurelia-framework';
import { MdcDialog } from '@aurelia-mdc-web/dialog';

@autoinject
@useView('./create-corporation-dialog.html')
export class CreateCorporationDialog {
  constructor(private dialog: MdcDialog) { }

  model: { name: string };

  activate(model: { name: string }) {
    this.model = model;
  }
}
